module.exports = __webpack_public_path__ + "img/responsive hospitium-15.26d54233.jpg";